import { format, formatDistanceToNow, isPast, isToday, isTomorrow } from 'date-fns';
import { ru } from 'date-fns/locale';

export const fmt = {
  date: d => d ? format(new Date(d), 'd MMM yyyy', { locale: ru }) : '—',
  dateShort: d => d ? format(new Date(d), 'd MMM', { locale: ru }) : '—',
  ago: d => d ? formatDistanceToNow(new Date(d), { addSuffix: true, locale: ru }) : '—',
  time: mins => {
    if (!mins) return '0м';
    const h = Math.floor(mins / 60), m = mins % 60;
    return h ? `${h}ч ${m}м` : `${m}м`;
  },
  dueBadge: d => {
    if (!d) return null;
    const date = new Date(d);
    if (isPast(date)) return { label: fmt.date(d), cls: 'text-red-500 bg-red-50 dark:bg-red-950' };
    if (isToday(date)) return { label: 'Сегодня', cls: 'text-orange-500 bg-orange-50 dark:bg-orange-950' };
    if (isTomorrow(date)) return { label: 'Завтра', cls: 'text-yellow-600 bg-yellow-50 dark:bg-yellow-950' };
    return { label: fmt.dateShort(d), cls: 'text-gray-500 bg-gray-100 dark:bg-gray-800' };
  }
};

export const PRIORITY = {
  critical: { label: 'Критический', color: '#ef4444', icon: '🔴' },
  high: { label: 'Высокий', color: '#f97316', icon: '🟠' },
  medium: { label: 'Средний', color: '#eab308', icon: '🟡' },
  low: { label: 'Низкий', color: '#22c55e', icon: '🟢' },
  none: { label: 'Нет', color: '#94a3b8', icon: '⚪' },
};

export const STATUS = {
  backlog: { label: 'Бэклог', color: '#94a3b8', bg: 'bg-gray-100 dark:bg-gray-800' },
  todo: { label: 'К выполнению', color: '#60a5fa', bg: 'bg-blue-50 dark:bg-blue-950' },
  in_progress: { label: 'В работе', color: '#f59e0b', bg: 'bg-amber-50 dark:bg-amber-950' },
  review: { label: 'На ревью', color: '#a78bfa', bg: 'bg-violet-50 dark:bg-violet-950' },
  done: { label: 'Готово', color: '#34d399', bg: 'bg-emerald-50 dark:bg-emerald-950' },
  cancelled: { label: 'Отменено', color: '#f43f5e', bg: 'bg-rose-50 dark:bg-rose-950' },
};

export const TASK_TYPE = {
  task: { label: 'Задача', icon: '📋', color: '#60a5fa' },
  bug: { label: 'Баг', icon: '🔧', color: '#ef4444' }
};

export const avatarInitials = (name = '') =>
  name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

export const classNames = (...cls) => cls.filter(Boolean).join(' ');
